export default ({ COLORS }) => ({
  titleLink: {
    color: COLORS.BLUE.NORMAL,
    fontWeight: 'bold',
    textDecoration: 'none'
  }
})
